import type { LngLat } from "../adapters/types";
import { lngLatToMercator, mercatorToLngLat } from "../loaders/formats/shared";
import { EARTH_RADIUS_METERS } from "./measure";

const WEB_MERCATOR_RADIUS_METERS = 6_378_137;

export function gridStepInMercator(stepMeters: number, latitude: number): number {
  return (stepMeters * WEB_MERCATOR_RADIUS_METERS) / (EARTH_RADIUS_METERS * Math.cos((latitude * Math.PI) / 180));
}

export function snapLngLatToGrid(point: LngLat, stepMeters: number): LngLat {
  const step = gridStepInMercator(stepMeters, point[1]);
  const [x, y] = lngLatToMercator(point);

  return mercatorToLngLat([Math.round(x / step) * step, Math.round(y / step) * step]);
}
